import React, { Suspense, useState } from 'react';
import { Button, type TableProps } from 'antd';
import TableComponent from '@/components/table';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { IDataModal } from '@/interfaces/dataModal';
import { ILocationCheckingRes } from '@/interfaces/location';
import { getFullLocationAddress } from '@/utils/customerUtils';
import { formatNumber } from '@/utils/dataUtils';
import ShippingAddressModal from './shipping-address-modal';

interface IProps {
  items: ILocationCheckingRes[];
  onActioned: () => void;
}

const _dataModal: IDataModal<ILocationCheckingRes> = {
  open: false,
};

const LocationCheckingTable = ({ items, onActioned }: IProps) => {
  dayjs.extend(relativeTime);
  const [dataModal, setDataModal] = useState<IDataModal<ILocationCheckingRes>>({
    ..._dataModal,
  });

  const columns: TableProps<ILocationCheckingRes>['columns'] = [
    {
      title: 'BU',
      dataIndex: 'businessUnitName',
      key: 'businessUnitName',
      align: 'center',
      width: 100,
    },
    {
      title: 'ORDER NO.',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      width: 120,
    },
    {
      title: 'Sales',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Customer',
      dataIndex: 'customerName',
      key: 'customerName',
    },
    {
      title: 'Short Name',
      dataIndex: 'shortName',
      key: 'shortName',
    },
    {
      title: 'Shipping Adress',
      dataIndex: 'address',
      key: 'address',
      render: (_, rec) => getFullLocationAddress(rec),
    },
    {
      title: 'Original Lo.',
      dataIndex: 'address',
      key: 'address',
      render: (_, rec) => `${rec.lat || '0'}, ${rec.lng || '0'}`,
    },
    {
      title: 'Driver Lo.',
      dataIndex: 'address',
      key: 'address',
      render: (_, rec) => `${rec.driverLat}, ${rec.driverLng}`,
    },
    {
      title: 'Distance',
      dataIndex: 'distance',
      key: 'distance',
      render: _ => formatNumber(_ || 0) + ' km.',
    },
    {
      title: '',
      dataIndex: 'id',
      key: 'action',
      className: 'font-medium',
      align: 'center',
      width: 120,
      render: (_, rec) => (
        <Button
          ghost
          type="primary"
          size="small"
          onClick={() =>
            setDataModal({ open: true, id: rec.shippingAddressId, item: rec })
          }
        >
          Update
        </Button>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<ILocationCheckingRes>
        columns={columns}
        data={{ data: items, totalRecords: items?.length }}
        loading={false}
        showPagination={false}
      />
      <Suspense>
        {dataModal?.open && (
          <ShippingAddressModal
            dataModal={dataModal}
            handleOk={function (): void {
              setDataModal({ ..._dataModal });
              onActioned();
            }}
            handleCancel={function (): void {
              setDataModal({ ..._dataModal });
            }}
          />
        )}
      </Suspense>
    </div>
  );
};

export default LocationCheckingTable;
